// Translations for easywebswiss.ch - Multilingual Support
// DE (German - Primary), IT (Italian), EN (English), ES (Spanish)

export const translations = {
  de: {
    // Navigation
    nav: {
      leistungen: "Leistungen",
      warumWir: "Warum wir",
      projekte: "Projekte",
      marketing: "Marketing & SEO",
      ueberUns: "Über uns",
      jobs: "Jobs",
      kontakt: "Kontakt",
      blog: "Blog"
    },
    
    // Hero
    hero: {
      title: "Swiss Made",
      subtitle: "Web Solutions",
      description: "Professionelles Webdesign, SEO & Online-Marketing für KMU in der Schweiz. Ihre Website in 24 Stunden – Swiss Made Qualität.",
      cta: "Kontaktiere uns für eine individuelle Offerte",
      scrollToExplore: "Scrollen zum Entdecken",
      swissExperts: "Schweizer Experten"
    },
    
    // Services
    services: {
      title: "Leistungen",
      subtitle: "Was wir für Sie tun",
      items: [
        { title: "Webdesign", description: "Modernes, benutzerfreundliches Webdesign, das Ihre Marke perfekt repräsentiert.", icon: "Monitor" },
        { title: "SEO Schweiz", description: "Suchmaschinenoptimierung speziell für den Schweizer Markt.", icon: "Search" },
        { title: "Online Marketing", description: "Ganzheitliche Online-Marketing-Strategien für nachhaltiges Wachstum.", icon: "TrendingUp" },
        { title: "Website Betreuung", description: "Technische Betreuung und Support für Ihre Website.", icon: "Settings" },
        { title: "Content Creation", description: "Professionelle Texte und Inhalte für Ihre Zielgruppe.", icon: "FileText" },
        { title: "24h Lieferung", description: "Express-Service für dringende Projekte.", icon: "Zap" }
      ]
    },
    
    // Why Us
    whyUs: {
      title: "Warum easywebswiss.ch?",
      subtitle: "Ihre Vorteile",
      items: [
        { title: "Schweizer Experten", description: "Lokale Expertise mit internationalem Know-how." },
        { title: "Swiss Made Qualität", description: "Höchste Qualitätsstandards und Präzision." },
        { title: "Persönliche Betreuung", description: "Direkter Kontakt zu Ihrem Ansprechpartner." },
        { title: "Faire Preise", description: "Transparente Preisgestaltung ohne versteckte Kosten." }
      ]
    },
    
    // Projects
    projects: {
      title: "Projekte",
      subtitle: "Ausgewählte Arbeiten",
      viewAll: "Alle Projekte ansehen",
      partners: "Unsere Partner"
    },
    
    // Marketing
    marketing: {
      title: "Marketing & SEO",
      subtitle: "Digitale Strategien für Ihren Erfolg",
      description: "Wir entwickeln massgeschneiderte Online-Marketing-Strategien.",
      features: ["SEO Optimierung für Schweizer KMU", "Google Ads & Social Media Marketing", "Content Marketing & Strategie", "Analytics & Performance Tracking"]
    },
    
    // Team
    team: {
      title: "Über uns",
      subtitle: "Das Team hinter easywebswiss.ch"
    },
    
    // Jobs
    jobs: {
      title: "Jobs",
      subtitle: "Werde Teil unseres Teams",
      openPositions: "Offene Stellen",
      noPositions: "Aktuell keine offenen Stellen",
      applyNow: "Jetzt bewerben"
    },
    
    // Contact
    contact: {
      title: "Kontakt",
      subtitle: "Lassen Sie uns sprechen",
      form: {
        name: "Name",
        email: "E-Mail",
        phone: "Telefon (optional)",
        company: "Firma (optional)",
        message: "Ihre Nachricht",
        submit: "Nachricht senden",
        sending: "Wird gesendet...",
        success: "Vielen Dank! Wir melden uns in Kürze.",
        error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut."
      },
      info: { address: "Adresse", email: "E-Mail", phone: "Telefon" }
    },
    
    // Newsletter
    newsletter: {
      title: "Newsletter",
      description: "Bleiben Sie informiert über Web-Trends und Tipps.",
      placeholder: "Ihre E-Mail-Adresse",
      submit: "Anmelden",
      success: "Vielen Dank für Ihre Anmeldung!",
      error: "Ein Fehler ist aufgetreten."
    },
    
    // Footer
    footer: {
      rights: "Alle Rechte vorbehalten",
      legal: { datenschutz: "Datenschutz", impressum: "Impressum", agb: "AGB", cookies: "Cookie-Richtlinie" }
    },
    
    // Cookie Banner
    cookies: {
      title: "Cookie-Einstellungen",
      description: "Wir verwenden Cookies, um Ihre Erfahrung zu verbessern.",
      accept: "Alle akzeptieren",
      reject: "Nur notwendige",
      settings: "Einstellungen"
    },
    
    // Blog
    blog: {
      title: "Blog",
      subtitle: "Wissen & Insights",
      readMore: "Weiterlesen",
      backToBlog: "Zurück zum Blog"
    },
    
    // Common
    common: {
      learnMore: "Mehr erfahren",
      getStarted: "Jetzt starten",
      contactUs: "Kontaktieren Sie uns"
    }
  },
  
  it: {
    nav: {
      leistungen: "Servizi",
      warumWir: "Perché noi",
      projekte: "Progetti",
      marketing: "Marketing & SEO",
      ueberUns: "Chi siamo",
      jobs: "Lavoro",
      kontakt: "Contatto",
      blog: "Blog"
    },
    hero: {
      title: "Swiss Made",
      subtitle: "Soluzioni Web",
      description: "Web design professionale, SEO e marketing online per PMI in Svizzera. Il vostro sito web in 24 ore – qualità Swiss Made.",
      cta: "Contattateci per un preventivo",
      scrollToExplore: "Scorri per scoprire",
      swissExperts: "Esperti Svizzeri"
    },
    services: {
      title: "Servizi",
      subtitle: "Cosa facciamo per voi",
      items: [
        { title: "Web Design", description: "Design web moderno e user-friendly che rappresenta perfettamente il vostro marchio.", icon: "Monitor" },
        { title: "SEO Svizzera", description: "Ottimizzazione per i motori di ricerca specifica per il mercato svizzero.", icon: "Search" },
        { title: "Marketing Online", description: "Strategie di marketing online complete per una crescita sostenibile.", icon: "TrendingUp" },
        { title: "Manutenzione Siti", description: "Supporto tecnico e manutenzione per il vostro sito web.", icon: "Settings" },
        { title: "Creazione Contenuti", description: "Testi professionali ottimizzati per il vostro pubblico target.", icon: "FileText" },
        { title: "Consegna 24h", description: "Servizio express per progetti urgenti.", icon: "Zap" }
      ]
    },
    whyUs: {
      title: "Perché easywebswiss.ch?",
      subtitle: "I vostri vantaggi",
      items: [
        { title: "Esperti Svizzeri", description: "Competenza locale con know-how internazionale." },
        { title: "Qualità Swiss Made", description: "I più alti standard di qualità e precisione." },
        { title: "Assistenza Personale", description: "Contatto diretto con il vostro referente." },
        { title: "Prezzi Equi", description: "Prezzi trasparenti senza costi nascosti." }
      ]
    },
    projects: { title: "Progetti", subtitle: "Lavori selezionati", viewAll: "Vedi tutti i progetti", partners: "I nostri partner" },
    marketing: { title: "Marketing & SEO", subtitle: "Strategie digitali per il vostro successo", description: "Sviluppiamo strategie di marketing online su misura.", features: ["SEO per PMI svizzere", "Google Ads & Social Media", "Content Marketing", "Analytics & Tracking"] },
    team: { title: "Chi siamo", subtitle: "Il team dietro easywebswiss.ch" },
    jobs: { title: "Lavoro", subtitle: "Unisciti al nostro team", openPositions: "Posizioni aperte", noPositions: "Nessuna posizione aperta", applyNow: "Candidati ora" },
    contact: {
      title: "Contatto",
      subtitle: "Parliamone",
      form: {
        name: "Nome",
        email: "E-Mail",
        phone: "Telefono (opzionale)",
        company: "Azienda (opzionale)",
        message: "Il vostro messaggio",
        submit: "Invia messaggio",
        sending: "Invio in corso...",
        success: "Grazie! Vi contatteremo presto.",
        error: "Si è verificato un errore. Riprovate."
      },
      info: { address: "Indirizzo", email: "E-Mail", phone: "Telefono" }
    },
    newsletter: { title: "Newsletter", description: "Restate informati su tendenze e consigli web.", placeholder: "Il vostro indirizzo e-mail", submit: "Iscriviti", success: "Grazie per l'iscrizione!", error: "Si è verificato un errore." },
    footer: { rights: "Tutti i diritti riservati", legal: { datenschutz: "Privacy", impressum: "Impressum", agb: "Termini", cookies: "Cookie" } },
    cookies: { title: "Impostazioni Cookie", description: "Utilizziamo i cookie per migliorare la vostra esperienza.", accept: "Accetta tutti", reject: "Solo necessari", settings: "Impostazioni" },
    blog: { title: "Blog", subtitle: "Conoscenze & Insights", readMore: "Leggi di più", backToBlog: "Torna al blog" },
    common: { learnMore: "Scopri di più", getStarted: "Inizia ora", contactUs: "Contattateci" }
  },
  
  en: {
    nav: {
      leistungen: "Services",
      warumWir: "Why Us",
      projekte: "Projects",
      marketing: "Marketing & SEO",
      ueberUns: "About Us",
      jobs: "Jobs",
      kontakt: "Contact",
      blog: "Blog"
    },
    hero: {
      title: "Swiss Made",
      subtitle: "Web Solutions",
      description: "Professional web design, SEO & online marketing for SMEs in Switzerland. Your website in 24 hours – Swiss Made quality.",
      cta: "Contact us for a quote",
      scrollToExplore: "Scroll to explore",
      swissExperts: "Swiss Experts"
    },
    services: {
      title: "Services",
      subtitle: "What we do for you",
      items: [
        { title: "Web Design", description: "Modern, user-friendly web design that perfectly represents your brand.", icon: "Monitor" },
        { title: "SEO Switzerland", description: "Search engine optimization specifically for the Swiss market.", icon: "Search" },
        { title: "Online Marketing", description: "Comprehensive online marketing strategies for sustainable growth.", icon: "TrendingUp" },
        { title: "Website Maintenance", description: "Technical support and maintenance for your website.", icon: "Settings" },
        { title: "Content Creation", description: "Professional content optimized for your target audience.", icon: "FileText" },
        { title: "24h Delivery", description: "Express service for urgent projects.", icon: "Zap" }
      ]
    },
    whyUs: {
      title: "Why easywebswiss.ch?",
      subtitle: "Your advantages",
      items: [
        { title: "Swiss Experts", description: "Local expertise with international know-how." },
        { title: "Swiss Made Quality", description: "Highest quality standards and precision." },
        { title: "Personal Support", description: "Direct contact with your contact person." },
        { title: "Fair Prices", description: "Transparent pricing without hidden costs." }
      ]
    },
    projects: { title: "Projects", subtitle: "Selected works", viewAll: "View all projects", partners: "Our partners" },
    marketing: { title: "Marketing & SEO", subtitle: "Digital strategies for your success", description: "We develop customized online marketing strategies.", features: ["SEO for Swiss SMEs", "Google Ads & Social Media", "Content Marketing", "Analytics & Tracking"] },
    team: { title: "About Us", subtitle: "The team behind easywebswiss.ch" },
    jobs: { title: "Jobs", subtitle: "Join our team", openPositions: "Open positions", noPositions: "No open positions", applyNow: "Apply now" },
    contact: {
      title: "Contact",
      subtitle: "Let's talk",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone (optional)",
        company: "Company (optional)",
        message: "Your message",
        submit: "Send message",
        sending: "Sending...",
        success: "Thank you! We'll get back to you soon.",
        error: "An error occurred. Please try again."
      },
      info: { address: "Address", email: "Email", phone: "Phone" }
    },
    newsletter: { title: "Newsletter", description: "Stay informed about web trends and tips.", placeholder: "Your email address", submit: "Subscribe", success: "Thank you for subscribing!", error: "An error occurred." },
    footer: { rights: "All rights reserved", legal: { datenschutz: "Privacy Policy", impressum: "Imprint", agb: "Terms", cookies: "Cookie Policy" } },
    cookies: { title: "Cookie Settings", description: "We use cookies to improve your experience.", accept: "Accept all", reject: "Only necessary", settings: "Settings" },
    blog: { title: "Blog", subtitle: "Knowledge & Insights", readMore: "Read more", backToBlog: "Back to blog" },
    common: { learnMore: "Learn more", getStarted: "Get started", contactUs: "Contact us" }
  },
  
  es: {
    nav: {
      leistungen: "Servicios",
      warumWir: "Por qué nosotros",
      projekte: "Proyectos",
      marketing: "Marketing & SEO",
      ueberUns: "Sobre nosotros",
      jobs: "Empleo",
      kontakt: "Contacto",
      blog: "Blog"
    },
    hero: {
      title: "Swiss Made",
      subtitle: "Soluciones Web",
      description: "Diseño web profesional, SEO y marketing online para PYMES en Suiza. Su sitio web en 24 horas – calidad Swiss Made.",
      cta: "Contáctenos para un presupuesto",
      scrollToExplore: "Desplázate para explorar",
      swissExperts: "Expertos Suizos"
    },
    services: {
      title: "Servicios",
      subtitle: "Lo que hacemos por usted",
      items: [
        { title: "Diseño Web", description: "Diseño web moderno y fácil de usar que representa perfectamente su marca.", icon: "Monitor" },
        { title: "SEO Suiza", description: "Optimización para motores de búsqueda específica para el mercado suizo.", icon: "Search" },
        { title: "Marketing Online", description: "Estrategias integrales de marketing online para un crecimiento sostenible.", icon: "TrendingUp" },
        { title: "Mantenimiento Web", description: "Soporte técnico y mantenimiento para su sitio web.", icon: "Settings" },
        { title: "Creación de Contenido", description: "Contenido profesional optimizado para su público objetivo.", icon: "FileText" },
        { title: "Entrega 24h", description: "Servicio express para proyectos urgentes.", icon: "Zap" }
      ]
    },
    whyUs: {
      title: "¿Por qué easywebswiss.ch?",
      subtitle: "Sus ventajas",
      items: [
        { title: "Expertos Suizos", description: "Experiencia local con know-how internacional." },
        { title: "Calidad Swiss Made", description: "Los más altos estándares de calidad y precisión." },
        { title: "Atención Personal", description: "Contacto directo con su persona de referencia." },
        { title: "Precios Justos", description: "Precios transparentes sin costos ocultos." }
      ]
    },
    projects: { title: "Proyectos", subtitle: "Trabajos seleccionados", viewAll: "Ver todos los proyectos", partners: "Nuestros socios" },
    marketing: { title: "Marketing & SEO", subtitle: "Estrategias digitales para su éxito", description: "Desarrollamos estrategias de marketing online a medida.", features: ["SEO para PYMES suizas", "Google Ads y redes sociales", "Marketing de contenidos", "Analytics y seguimiento"] },
    team: { title: "Sobre nosotros", subtitle: "El equipo detrás de easywebswiss.ch" },
    jobs: { title: "Empleo", subtitle: "Únete a nuestro equipo", openPositions: "Posiciones abiertas", noPositions: "Sin posiciones abiertas", applyNow: "Aplicar ahora" },
    contact: {
      title: "Contacto",
      subtitle: "Hablemos",
      form: {
        name: "Nombre",
        email: "Correo electrónico",
        phone: "Teléfono (opcional)",
        company: "Empresa (opcional)",
        message: "Su mensaje",
        submit: "Enviar mensaje",
        sending: "Enviando...",
        success: "¡Gracias! Nos pondremos en contacto pronto.",
        error: "Ocurrió un error. Por favor, inténtelo de nuevo."
      },
      info: { address: "Dirección", email: "Correo electrónico", phone: "Teléfono" }
    },
    newsletter: { title: "Newsletter", description: "Manténgase informado sobre tendencias y consejos web.", placeholder: "Su correo electrónico", submit: "Suscribirse", success: "¡Gracias por suscribirse!", error: "Ocurrió un error." },
    footer: { rights: "Todos los derechos reservados", legal: { datenschutz: "Privacidad", impressum: "Aviso legal", agb: "Términos", cookies: "Política de cookies" } },
    cookies: { title: "Configuración de Cookies", description: "Usamos cookies para mejorar su experiencia.", accept: "Aceptar todas", reject: "Solo necesarias", settings: "Configuración" },
    blog: { title: "Blog", subtitle: "Conocimiento & Insights", readMore: "Leer más", backToBlog: "Volver al blog" },
    common: { learnMore: "Más información", getStarted: "Comenzar", contactUs: "Contáctenos" }
  }
};

export const getTranslation = (lang, path) => {
  const keys = path.split('.');
  let result = translations[lang] || translations.de;
  
  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key];
    } else {
      result = translations.de;
      for (const k of keys) {
        if (result && typeof result === 'object' && k in result) {
          result = result[k];
        } else {
          return path;
        }
      }
      break;
    }
  }
  
  return result;
};
